import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { AdvancedRequestListing, AdvancedRequestApprovalDetailListing } from './Pages';

export const AdvancedRequestRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={AdvancedRequestListing} />
        <Route exact path = {`${match.path}/AddEdit`} component={AdvancedRequestApprovalDetailListing} /> 
    </Fragment>
)